<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="form-row"> 
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :blockano="true" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            placeholder="Nome do Paciente..."
                            v-model="filtros.nome_paciente" />
                    </div>
                </div>
            </div>
        </div>

        <az-empty-state 
            icon="fa-solid fa-user" 
            :msg="dados === null ? 'Buscar Pacientes' : 'Nenhum Paciente Identificado'" 
            :action="dados === null ? 'Buscar' : ''"
            :method="load"
            v-if="!dados || !dados.length" />

        <template v-else-if="selecionado">
            <div class="alert alert-primary d-flex justify-content-between">
                <div>
                    <div>
                        <span class="lead">{{ selecionado.paciente.st_nome }},</span> {{ selecionado.paciente.cadastro.ch_sexo }}, {{ selecionado.paciente.cadastro.idade }} 
                    </div>
                    <div v-if="selecionado.paciente.cadastro.st_cpf">
                        CPF: {{ $util.formatMask(selecionado.paciente.cadastro.st_cpf, 'cpf') }}
                    </div>
                </div>
                <button type="button" class="btn btn-primary" @click="selecionado = null">Voltar</button>
            </div>

            <portal-resultados :id_paciente="selecionado.id_paciente" />
        </template>

        <template v-else>

            <div class="list-group">
                <a href="#" @click.prevent="selecionado = item" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(item, iix) in dados" :key="iix">
                    <div>
                        <div>
                            <span class="lead">{{ item.paciente.st_nome }},</span> {{ item.paciente.cadastro.ch_sexo }}, {{ item.paciente.cadastro.idade }} 
                        </div>
                        <div v-if="item.paciente.cadastro.st_cpf">
                            CPF: {{ $util.formatMask(item.paciente.cadastro.st_cpf, 'cpf') }}
                        </div>
                    </div>
                    <div class="text-right">
                        {{ $util.getFormatDate(item.dt_inicio) }}
                        <div>#{{ item.id_atendimento }}</div>
                    </div>
                </a>
            </div>

            <pre v-if="false">{{ dados }}</pre>

        </template>

        
    </div>
</template>

<script>
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import PortalResultados from './PortalResultados.vue';

export default {
    data() {
        return { 
            filtros: { 
                periodo: 'm', 
                nome_paciente: '', 
            },
            dados: null, 
            selecionado: null, 
        }
    },

    components: {
        AzPeriodo,
        AzInput, 
        AzEmptyState, 
        PortalResultados, 
    },

    methods: { 
        load() { 
            this.selecionado = null; 

            this.$util.load(this, { 
                service: 'laudos',
                func: 'pacientes_por_solicitante', 
                parms: { 
                    ...this.filtros, 
                },
                loadTo: res => { 
                    this.dados = res.lista;
                }
            });
        }
    },
}
</script>
